import {useEffect, useState } from "react";
import ApiRequest from "../../helper/ApiRequest";
import { ApiEndpoints } from "../../helper/ApiEndpoints";
import DataTable from "../../component/DataTable";
import AdminHeader from "../../component/AdminHeader";

const vistListEndpoint = ApiEndpoints.applynow.applyList;

const tableHeader = ["date", "First Name", "Last Name", "gender", "DOB", "school year", "Branch", "applied class", "previous school", "Parent Name", "phone", "email", "Father Occupation", "mother phone", "Address", "city", "state", "pincode", "country", "source URL"]; 

const tbody = ["createdAt", "student_first_name", "student_last_name", "gender", "dob", "school_year", "preferred_branch", "applied_class", "student_previous_school", "parent_name", "phone", "email", "father_occupation", "mother_phone", "address", "city", "state", "pincode", "country", "source_url"];

export default function ApplyNow() {
    const [data, setData] = useState([]);

    const dataFetch = async () => {
        try {
            const response = await ApiRequest("GET", vistListEndpoint);
            const result = response.applynow_data;
            setData(result);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        dataFetch();
    }, []);


    const pagename = {
      name: 'Apply Now',
      user: 'Admin',
      innerpage: 'Apply Now'
    }

  return (
    <>
    <AdminHeader pagename={pagename}/>

    <div className="add-btn-section contact-manage-tab">
        <DataTable
          data={data}
          tableHeader={tableHeader}
          tbody={tbody}
          showAction={false}
        />
    </div>
    </>
  )
}
